const KEY_RE = /^[A-Za-z_][A-Za-z0-9_]*$/;
export function tokenizeJsonPath(path) {
    if (path.startsWith('$'))
        return { error: 'root prefix ($) not supported' };
    if (path.includes('..'))
        return { error: 'recursive descent (..) not supported' };
    if (/\[\?/.test(path))
        return { error: 'filter predicates not supported' };
    if (path.length === 0)
        return { error: 'empty path' };
    const tokens = [];
    let i = 0;
    while (i < path.length) {
        if (path[i] === '.') {
            i++;
            continue;
        }
        if (path[i] === '[') {
            const close = path.indexOf(']', i);
            if (close === -1)
                return { error: 'unclosed bracket' };
            const body = path.slice(i + 1, close);
            if (body === '*')
                tokens.push({ kind: 'idx', wildcard: true });
            else if (/^\d+$/.test(body))
                tokens.push({ kind: 'idx', index: Number(body) });
            else
                return { error: `invalid bracket body: ${body}` };
            i = close + 1;
            continue;
        }
        const match = path.slice(i).match(/^[A-Za-z_][A-Za-z0-9_]*/);
        if (!match)
            return { error: `invalid character at position ${i}` };
        if (!KEY_RE.test(match[0]))
            return { error: `invalid key: ${match[0]}` };
        tokens.push({ kind: 'key', name: match[0] });
        i += match[0].length;
    }
    return { tokens };
}
//# sourceMappingURL=json-grammar.js.map